"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=scopesObject.js.map